import { render, staticRenderFns } from "./ForgotPasswordRoute.vue?vue&type=template&id=b12fe4d6"
import script from "./ForgotPasswordRoute.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordRoute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports